var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.227,
    height: 18.227,
    viewBox: "0 0 18.227 18.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-373.887 -679.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(374 680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    "data-name": "edit",
    transform: "translate(0.637 0.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M9.482,4H3.663A1.663,1.663,0,0,0,2,5.663V17.3a1.663,1.663,0,0,0,1.663,1.663H15.3A1.663,1.663,0,0,0,16.963,17.3V11.482",
    transform: "translate(-2 -2.237)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M16.729,2.4a1.763,1.763,0,0,1,2.494,2.494l-7.9,7.9L8,13.618l.831-3.325Z",
    transform: "translate(-3.012 -1.879)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.183ffe569eb6bacc2098dfa93bf2eab4.svg";
export { ForwardRef as ReactComponent };